import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && user.emailVerified) {
        navigate("/dashboard");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (!user.emailVerified) {
        toast.error("Please verify your email before logging in.");
        return;
      }

      toast.success("Login successful!");
      navigate("/dashboard");
    } catch (err) {
      if (err.code === "auth/invalid-credential") {
        toast.error("Invalid email or password. Please try again.");
      } else if (err.code === "auth/user-not-found") {
        toast.error("No user found with this email.");
      } else if (err.code === "auth/wrong-password") {
        toast.error("Incorrect password.");
      } else {
        toast.error("Login failed. Please try again later.");
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.leftPanel}>
        <div style={styles.card}>
          <h2 style={styles.title}>Log In & Start Something Amazing</h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            {renderInput("Email", "email", email, setEmail, "email", "you@example.com")}
            {renderInput("Password", "password", password, setPassword, "password", "••••••••")}

            <div style={{ marginBottom: "1rem", textAlign: "right" }}>
              <Link to="/forgotpassword" style={styles.link}>
                Forgot password?
              </Link>
            </div>

            <button
              type="submit"
              style={styles.primaryBtn}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#7320d8")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#8F27FF")}
            >
              Login
            </button>

            <p style={styles.footerText}>
              Don’t have an account?{" "}
              <Link to="/signup" style={styles.link}>
                Create one
              </Link>
            </p>
          </form>
        </div>
      </div>

      <div style={styles.rightPanel}>
        <div style={{ textAlign: "center", animation: "fadeIn 1.2s ease-out" }}>
          <h1 style={{ fontSize: 36, fontWeight: "bold", marginBottom: 20 }}>
            Welcome Back!
          </h1>
          <p style={{ fontSize: 18, maxWidth: 400 }}>
            Log in to access your account and continue sharing your voice through
            surveys. Earn rewards for your valuable insights!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;

const renderInput = (
  label,
  name,
  value,
  setValue,
  type = "text",
  placeholder = ""
) => (
  <>
    <label htmlFor={name} style={styles.label}>{label}</label>
    <input
      id={name}
      name={name}
      type={type}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      required
      style={styles.input}
      onFocus={(e) => (e.target.style.boxShadow = "0 0 0 3px rgba(143, 39, 255, 0.2)")}
      onBlur={(e) => (e.target.style.boxShadow = "none")}
    />
  </>
);

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif",
  },
  leftPanel: {
    flex: 1,
    overflowY: "auto",
    backgroundColor: "#f9f9f9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center", // Centered vertically
    padding: "2rem",
  },
  rightPanel: {
    flex: 1,
    background: "linear-gradient(to bottom right, #8F27FF, #200D41)",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: "450px",
    padding: "2rem",
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#200D41",
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "6px",
    fontWeight: 600,
    fontSize: "15px",
    color: "#333",
  },
  input: {
    padding: "12px 14px",
    marginBottom: "20px",
    borderRadius: "10px",
    border: "1.5px solid #d0cde1",
    fontSize: "15px",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    outline: "none",
  },
  primaryBtn: {
    backgroundColor: "#8F27FF",
    color: "#fff",
    border: "none",
    padding: "14px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    marginTop: "12px",
  },
  link: {
    color: "#8F27FF",
    textDecoration: "none",
    fontWeight: 600,
    transition: "color 0.2s ease",
  },
  footerText: {
    fontSize: "14px",
    color: "#444",
    textAlign: "center",
    marginTop: "20px",
  },
};
